import styled from 'styled-components';

const Divider = styled.div`
  border-bottom: 1px solid ${props => props.theme.divider}
`;

export default Divider;

